import {Log} from '../../shared/log';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {AppConfig} from '../../app.config';
import {AuthTokenService} from './auth-token.service';
import {WindowRef} from '../window-ref/window.ref';
import {TokenInfoService} from './token-info.service';
import {FeatureToggles} from '../../shared/feature-toggles';
import 'rxjs/add/operator/filter';
import {KeycloakLogoutOptions, KeycloakPromise} from './keycloak/keycloak';
import {KeycloakConfig} from './keycloak-config';
import {AppComponent} from '../../app.component';

// console.log(KeycloakConfig);
const log = Log.getLogger('AuthService');

export interface  AuthServiceI {
  keycloakConfig: KeycloakConfig;

  login(level: any, shouldReturnToCurrentPath): KeycloakPromise<void, void>;

  getAuthObj();

  renewTokens(app: AppComponent): void;

  logout(): void;

  isLoggedIn(): boolean;

}

@Injectable()
export class AuthService implements  AuthServiceI {
  private home;
  // level 1/2 levels is now acr_values=urn:id.gov.au:tdif:acr:ip2:cl1, broker can't handle level1/level2 swap, nor can you tell on response.
  // we only request lvl2 eoi and if we get it great, else its treated as lvl1, i.e. if no dob in payload its lvl1.
  private level2Identifier = 'urn:au:qld:gov:authn:names:SAML:2.0:ac:AAL2:IRAL2:IAAL2';
  private level2SocialIdentifier = 'urn:au:qld:gov:authn:names:SAML:2.0:ac:AAL1:IRAL2:IAAL1';

  public keycloakConfig: KeycloakConfig;


  constructor(private router: Router,
              private authTokenService: AuthTokenService,
              private tokenInfoService: TokenInfoService,
              private windowRef: WindowRef,
              private appConfig: AppConfig,
              private featureToggles: FeatureToggles,
              private keycloakConfigHolder: KeycloakConfig
  ) {
    // log.info('auth service init called');

    this.home = appConfig.getValue('oidcClientUri');
    this.keycloakConfig = keycloakConfigHolder;
  }

  public login(level: any, shouldReturnToCurrentPath = true): KeycloakPromise<void, void> {
    return this.getAuthObj().login({
      redirectUri: this.home + '/oidc-callback.html',
      maxAge: 10
    })
  }

  public getAuthObj() {
      return this.keycloakConfig.keyCloakInstance;
  }

  public renewTokens(app: AppComponent): void {
    console.log('renewTokens called');
    const keycloak = this.getAuthObj();
    keycloak.updateToken(400)
      .then(function (refreshed) {
        if (refreshed) {
          log.info('Token was successfully refreshed');
          let timeSkew = keycloak.timeSkew
          if (timeSkew == null) {
            timeSkew = 0;
          }
          app._accessToken = keycloak.token;
          app._expiresAt = Math.round(keycloak.tokenParsed.exp + timeSkew) - 60; // ensure expires is 60 seconds before.
          localStorage.setItem('access_token', keycloak.token);
          localStorage.setItem('refreshToken', keycloak.refreshToken);
          localStorage.setItem('idToken', keycloak.idToken);
          localStorage.setItem('expires_in', Math.round(keycloak.tokenParsed.exp + timeSkew - new Date().getTime() / 1000).toString());
          localStorage.setItem('expiry', Math.round(keycloak.tokenParsed.exp + timeSkew - new Date().getTime() / 1000).toString());
          log.info('Finished updating local storage on token refresh');
          app.scheduleRenewal();
        } else {
          log.info('Token is still valid');
        }
      }).catch(function () {
      log.error('Failed to refresh the token, or the session has expired');
    });
  }

  // needs to call keycloak service
  public async logout() {
    await this.authTokenService.clear();
    const options: KeycloakLogoutOptions = { redirectUri: this.home + '/logout.html' }
    await this.getAuthObj().logout(options);
  }

  // needs to call keycloak service
  public isLoggedIn(): boolean {
    log.info('isLoggedIn function');
    let authenticated = this.getAuthObj().authenticated === true;
    if (authenticated) {
      // if token is expired then not authenticated.
      console.log('isLoggedIn and Authenticated')
      authenticated = this.getAuthObj().isTokenExpired(20) === false;
      console.log('isLoggedIn and NOT isTokenExpired' + authenticated)
    }
    if (!authenticated) {
      console.log('isLoggedIn and NOT authenticated');
      this.authTokenService.clear()
      console.log('cleared session storage');
    }
    log.info('isLoggedIn returns: ' + authenticated);
    return authenticated;
  }
}



// WEBPACK FOOTER //
// ./app/services/auth/auth.service.ts